import { RefObject, useEffect, useState } from "react";

type LoadStatusType = "idle" | "loading" | "loaded" | "error" | string;

/** Хук для отслеживанием статуса загрузки изображений */
const useOnLoadImages = ( ref: RefObject<HTMLElement> ) => {

	const [status, setStatus] = useState<LoadStatusType>("idle");

	useEffect(() => {

		const updateStatus = ( event: Event | ErrorEvent, images: HTMLImageElement[], hasError: boolean = false ) => {
			if ( hasError ) {
				setStatus( (event as ErrorEvent).message );
			}
			const isLoaded = images.map((image) => image.complete).every((item) => item === true);
			if ( isLoaded && event.target ) {
				setStatus( "loaded" );
				( event.target as HTMLImageElement).style.opacity = "1";
			}
		};

		if (!ref?.current) return;
		const imagesLoaded = Array.from(ref.current.querySelectorAll("img"));
		if (imagesLoaded.length === 0) {
			return;
		}
		setStatus( "loading" );
		imagesLoaded.forEach((image) => {
			image.style.opacity = "0";
			image.addEventListener("load", e => updateStatus( e, imagesLoaded), {
				once: true
			});
			image.addEventListener("error", e => updateStatus( e, imagesLoaded, true ), {
				once: true
			});
		});

		return;
	}, [ref] );

	return [ status ] as const;
};

export default useOnLoadImages;
